type QueryStringType = { [key: string]: string };

// this function requires full query string including `?`
export const queryStringParser = (queryString: string): QueryStringType => {
    const utm: QueryStringType = {};
    const parsed = queryString.substr(1).split(/=+|&+/);

    for (let i = 0; i < parsed.length; i += 2) {
        utm[parsed[i]] = parsed[i + 1];
    }
    return utm;
};
